module.exports = __webpack_public_path__ + "img/loan-manage.6f5df228.svg";